import mlAxios from './axios_ml'

export const getFirstInsight = (personId) =>
  mlAxios.get(`/short_term_recommendation/${personId}`)

export const getSecondInsight = (personId) =>
  mlAxios.get(`/long_term_recommendation/${personId}`)
